import { render, staticRenderFns } from "./UpToDateIntegration.vue?vue&type=template&id=e0431f4e&"
import script from "./UpToDateIntegration.vue?vue&type=script&lang=js&"
export * from "./UpToDateIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports